import axios, { AxiosResponse } from 'axios'
import { URLs } from '../config/env'
import { StorageEnum } from '@/enums/storage'

const token = localStorage.getItem(StorageEnum.token)
const api = axios.create({
  baseURL: URLs.BASE_URL,
  headers: { Authorization: `Bearer ${token}` },
})

export const getUriForStaticDocs = api.getUri().replace('/api', '')

export default api

export type Error = {
  message: string
}

export type HttpResponse<T, E> = [data: T | null, error: E | null]

export interface Response<T> {
  data: T
}

export const treatmentForErrors = async <T, E>(
  request: Promise<AxiosResponse<T, E>>,
): Promise<HttpResponse<T, E>> => {
  try {
    const response = (await request) as unknown as Response<T>
    return [response.data, null]
  } catch (err) {
    const error = (err?.response?.data?.error || err) as E
    return [null, error]
  }
}
